import { RootEpic } from 'typesafe-actions';

import { createGetEpic } from '../utils';
import { AccountDetailsRequestParams, getAccountDetailsAsync } from './actions';
import { forkJoin, Observable } from 'rxjs';

export const loadAccountDetailsAsync: RootEpic = (
  action$,
  state$,
  {
    getValidatorsUnstakingBalanceSubscription,
    getBidderDetailsDataSubscription,
    getAccountInfoSubscription,
    getValidatorsTotalRewardsSubscription,
    getPaginatedAccountCep18TokenListSubscription,
    getAccountContractPackagesSubscription,
  }
) =>
  createGetEpic<AccountDetailsRequestParams>(
    action$,
    getAccountDetailsAsync,
    (params: AccountDetailsRequestParams): Observable<any> =>
      forkJoin([
        getValidatorsUnstakingBalanceSubscription(params.unstackingParams),
        getBidderDetailsDataSubscription(params.biddersParams),
        getAccountInfoSubscription(params.accountParams),
        getValidatorsTotalRewardsSubscription(
          params.validatorTotalRewardParams
        ),
        getPaginatedAccountCep18TokenListSubscription(
          params.accountCep18TokensList
        ),
        getAccountContractPackagesSubscription(params.accountContractPackages),
      ])
  );
